import{on}from"./on";export const listenScroll=(handler,el)=>on(el||window,"scroll",handler,{capture:true,passive:true});export default listenScroll;